import { Trans, useTranslation } from 'react-i18next';

import { DetailErrorMessages } from '../../../contexts/websocket/WebsocketContext';
import {
  ImportProductAssignmentsErrorCode,
  ImportProductAssignmentsErrorCodeTranslationKeyMap,
  ImportProductsErrorCode,
  ImportProductsErrorCodeTranslationKeyMap,
} from '../../enums/import-file-error-code';

type DetailErrorMessageToastContentProps = {
  detailErrorMessages: DetailErrorMessages[];
  type: 'importProducts' | 'assignProducts';
};

const DetailErrorMessageToastContent = (
  props: DetailErrorMessageToastContentProps,
): JSX.Element => {
  const { t } = useTranslation();

  const getTranslatedErrorMessage = (errorMessage: string) => {
    const configMap = {
      importProducts: {
        errorCodes: ImportProductsErrorCode,
        translationMap: ImportProductsErrorCodeTranslationKeyMap,
        baseKey: 'toastMessages.importProducts.states.failure',
        fallbackKey: 'failedToImportProduct',
      },
      assignProducts: {
        errorCodes: ImportProductAssignmentsErrorCode,
        translationMap: ImportProductAssignmentsErrorCodeTranslationKeyMap,
        baseKey: 'toastMessages.assignProducts.states.failure',
        fallbackKey: 'failedToAssignProduct',
      },
    };

    const config = configMap[props.type];
    const isKnownError = Object.values(config.errorCodes).includes(errorMessage);

    const translationKey = isKnownError
      ? config.translationMap[errorMessage as keyof typeof config.translationMap]
      : config.fallbackKey;

    return t(`${config.baseKey}.${translationKey}`);
  };

  return (
    <div className='flex flex-column'>
      <div className='flex flex-row align-items-center gap-2'>
        <i className='pi pi-exclamation-triangle font text-4xl' />
        <h6 className='m-0'>{t(`toastMessages.${props.type}.states.failure.title`)}</h6>
      </div>
      <div className='overflow-auto w-full' style={{ maxHeight: 'calc(100vh - 200px)' }}>
        <ul>
          {props.detailErrorMessages?.map((detailErrorMessage) => {
            return (
              <li key={detailErrorMessage.row}>
                <Trans
                  i18nKey='toastMessages.detailedRowMessage'
                  values={{
                    rowNumber: detailErrorMessage.row + 2,
                    errorMessage: getTranslatedErrorMessage(detailErrorMessage.message),
                  }}
                  components={[<span key={0} />, <span key={1} className='font-bold' />]}
                />
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default DetailErrorMessageToastContent;
